var _defs, _metadata, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinearAlgebra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXl: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    viewBox: "747.9395 -976 33.06753 42.200005",
    width: 33.06753,
    height: 42.200005,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "CMU Serif",
    fontSize: 13,
    panose1: "2 0 8 3 0 0 0 0 0 0",
    unitsPerEm: 1000,
    underlinePosition: -100,
    underlineThickness: 50,
    slope: 0,
    xHeight: 444,
    capHeight: 686,
    ascent: 937.0019,
    descent: -308.00062,
    fontWeight: 700,
    fontStretch: "expanded"
  }, /*#__PURE__*/React.createElement("fontFaceSrc", null, /*#__PURE__*/React.createElement("fontFaceName", {
    name: "CMUSerif-Bold"
  }))))), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Produced by OmniGraffle 7.12.1 \n    ", /*#__PURE__*/React.createElement("dcDate", null, "2020-10-17 12:56:42 +0000"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1",
    strokeDasharray: "none",
    fill: "none",
    stroke: "none",
    strokeOpacity: 1,
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("title", null, "Canvas 1"), /*#__PURE__*/React.createElement("g", {
    id: "Canvas_1: Layer 1"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_47"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(752.9395 -957.4)",
    fill: "#ff7645"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "CMU Serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#ff7645",
    x: 0,
    y: 12
  }, "2"))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_46"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(753.10435 -971)",
    fill: "#00c0ec"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "CMU Serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#00c0ec",
    x: 0,
    y: 12
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_45"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(769.177 -957.4)",
    fill: "#00e64e"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "CMU Serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#00e64e",
    x: 0,
    y: 12
  }, "4"))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic_44"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(767.9395 -971)",
    fill: "#ffbc17"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "CMU Serif",
    fontSize: 13,
    fontWeight: 700,
    fill: "#ffbc17",
    x: 0,
    y: 12
  }, "3"))), /*#__PURE__*/React.createElement("g", {
    id: "Line_43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 751.7048 -970.6462 L 749 -970.6462 L 749 -942.3538 L 751.7048 -942.3538",
    stroke: "#aaa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 777.3023 -942.3538 L 780.0071 -942.3538 L 780.0071 -970.6462 L 777.3023 -970.6462",
    stroke: "#aaa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearAlgebra);
export default __webpack_public_path__ + "static/media/linear_algebra.6dbd5f019bf64f5c563f316e2329bd33.svg";
export { ForwardRef as ReactComponent };